<div mat-dialog-title>
  <div class="title-icon">
    <img src="assets/svg/personalise.svg" alt="" />
  </div>
  <div class="title-text">{{ 'personalize.title' | transloco }}</div>
</div>
<mat-dialog-content class="mat-typography">
  <form class="form">
    <h3>{{ 'personalize.kit_name' | transloco }}</h3>
    <mat-form-field>
      <input matInput [placeholder]="'personalize.kit_name_placeholder' | transloco" />
    </mat-form-field>
    <h3>{{ 'personalize.speaker_names' | transloco }}</h3>

    <div class="mic-settings">
      <div class="mic-settings__mic">
        <div class="icon" [style.color]="'#da291c'">
          <i class="fa fa-microphone"></i>
        </div>
        <mat-form-field>
          <input matInput [placeholder]="'personalize.microphone_name_placeholder' | transloco" />
        </mat-form-field>
      </div>

      <div class="mic-settings__mic">
        <div class="icon" [style.color]="'#ffb81c'">
          <i class="fa fa-microphone"></i>
        </div>
        <mat-form-field>
          <input matInput [placeholder]="'personalize.microphone_name_placeholder' | transloco" />
        </mat-form-field>
      </div>

      <div class="mic-settings__mic">
        <div class="icon" [style.color]="'#69b3e7'">
          <i class="fa fa-microphone"></i>
        </div>
        <mat-form-field>
          <input matInput [placeholder]="'personalize.microphone_name_placeholder' | transloco" />
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'personalize.cancel' | transloco }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'personalize.save' | transloco }}</button>
</mat-dialog-actions>
